"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultNestJsCrudExceptions = void 0;
const validate_error_exception_1 = require("./exceptions/other/validate-error.exception");
const index_1 = require("./index");
exports.DefaultNestJsCrudExceptions = [
    index_1.CommonNotFoundException,
    validate_error_exception_1.CommonValidateException,
    index_1.CommonForbiddenException,
    index_1.CommonBadRequestException,
    index_1.CommonInternalServerErrorException
];
//# sourceMappingURL=default-nestjs-crud.exceptions.js.map